import React,{useState} from "react";
import { useHistory } from "react-router-dom";
import {motion} from "framer-motion";
import {useSelector,useDispatch} from 'react-redux'
import {setIntro} from '../actions'

const contVariant={
  hidden:{
    x:"100vw"
  },
  visible:{
    x:0,
    transition:{
      delay:0.1,
      type:"spring",
      stiffness:80,
      mass:0.4,
      damping:8
    }
  }
}
const linkVariant={
  hover:{
    textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
    boxShadow:"2px 2px 10px rgba(0,0,0,0.8)",
    transition:{
      duration:0.2
    }
  }
}
export default function Intro() {
  const {name,intro}=useSelector(states=>states.resumeData)
  const dispatch=useDispatch()
  const history = useHistory();
  const [introData,setIntroData]=useState(intro)
  function handleSubmit(e) {
    e.preventDefault();
    dispatch(setIntro(introData))
    history.push("/additional-details");
  }
  return (
    <motion.div className="container" exit={{x:"-100vw"}}>
      <motion.div className="form"
        variants={contVariant}
        initial="hidden"
        animate="visible"
      >
        <h1>{name}, want to add an intro?</h1>
        <form onSubmit={handleSubmit}>
          <textarea rows="5" value={introData} onChange={(e)=>setIntroData(e.target.value)} placeholder="write about yourself"></textarea>
          <motion.button variants={linkVariant} whileHover="hover" type="submit">next</motion.button>
        </form>
      </motion.div>
    </motion.div>
  );
}
